class medioPagoMock {
    values = [
        { id: 1, codigoSunat: '001', nombre: 'Depósito en cuenta' },
        { id: 2, codigoSunat: '002', nombre: 'Giro' },
        { id: 3, codigoSunat: '003', nombre: 'Transferencia de fondos' },
        { id: 4, codigoSunat: '004', nombre: 'Orden de pago' },
        { id: 5, codigoSunat: '005', nombre: 'Tarjeta de débito' },
        { id: 6, codigoSunat: '006', nombre: 'Tarjeta de crédito emitida en el país por una empresa del sistema financiero' },
        { id: 7, codigoSunat: '007', nombre: 'Cheques con la cláusula de NO NEGOCIABLE, INTRANSFERIBLES, NO A LA ORDEN u otra equivalente' },
        { id: 8, codigoSunat: '008', nombre: 'Efectivo, por operaciones en las que no existe obligación de utilizar medio de pago' },
        { id: 9, codigoSunat: '009', nombre: 'Efectivo, en los demás casos' },
        { id: 10, codigoSunat: '010', nombre: 'Medios de pago usados en comercio exterior' },
        { id: 11, codigoSunat: '011', nombre: 'Documentos emitidos por EDPYMES y cooperativas no autorizadas a captar depósitos' },
        { id: 12, codigoSunat: '012', nombre: 'Tarjeta de crédito emitida por empresa no perteneciente al sistema financiero' },
        { id: 13, codigoSunat: '013', nombre: 'Tarjetas de crédito emitidas en el exterior por empresas bancarias o financieras no domiciliadas' },
        { id: 14, codigoSunat: '101', nombre: 'Transferencias – Comercio exterior' },
        { id: 15, codigoSunat: '102', nombre: 'Cheques bancarios - Comercio exterior' },
        { id: 16, codigoSunat: '103', nombre: 'Orden de pago simple - Comercio exterior' },
        { id: 17, codigoSunat: '104', nombre: 'Orden de pago documentario - Comercio exterior' },
        { id: 18, codigoSunat: '105', nombre: 'Remesa simple - Comercio exterior' },
        { id: 19, codigoSunat: '106', nombre: 'Remesa documentaria - Comercio exterior' },
        { id: 20, codigoSunat: '107', nombre: 'Carta de crédito simple - Comercio exterior' },
        { id: 21, codigoSunat: '108', nombre: 'Carta de crédito documentario - Comercio exterior' },
        { id: 22, codigoSunat: '999', nombre: 'Otros medios de pago' }
    ];
}

export default new medioPagoMock();
